export const Percent = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="9" cy="9" r="4" stroke="currentColor" stroke-width="2"/>
<circle cx="23" cy="23" r="4" stroke="currentColor" stroke-width="2"/>
<path d="M26.5609 5.38184L5.35099 26.5918" stroke="currentColor" stroke-width="2"/>
</svg>`;
